import type { Client } from '@hero/schema';
import { getObjectId } from '@hero/schema';
import { useTranslation } from 'react-i18next';
import { useMyOrdersListApi } from '@hero/api-hooks';
import { SharedList } from '../../../app/List/List';
import { OrderCard } from '../../Order/Card/OrderCard';

export interface ClientOrdersTabProps {
  client: Client;
  displayForUser: 'customer' | 'carrier';
}

export function ClientOrdersTab({ client, displayForUser }: ClientOrdersTabProps) {
  const { t } = useTranslation(['m-client']);

  // Tenant-aware unified feed scoped to "my orders involving this Client".
  // The server resolves the viewer's tenant identity from the auth context
  // and AND-narrows by the `client_id` tenant entry on the Order.
  const ordersQuery = useMyOrdersListApi({
    clientId: getObjectId(client._id),
  });

  return (
    <div className="flex flex-col gap-3 p-5">
      <SharedList
        query={ordersQuery}
        emptyMessage={t('drawer.no_orders')}
        className="gap-3"
        renderItem={order => <OrderCard order={order} displayForUser={displayForUser} />}
      />
    </div>
  );
}
